<div
  class="svg-wrapper"
  [ngStyle]="{
    color: fill,
    stroke: stroke
  }"
  [innerHTML]="svgContent"></div>
